export const mockPrescriptions = {
    "totalPaginas": 1,
    "pagina": 1,
    "itemsPorPagina": 10,
    "items": [
        {
            "dni": "5301249",
            "nombre": "AMANDA ELVIRA RODRIGUEZ",
            "telefono": "1159580601",
            "telefonoCelular": "",
            "email": "amandaelvirarodriguez@gmail.com",
            "nroPedido": "3053",
            "fechaEmision": "20/10/2025",
            "situacion": "A",
            "procedimientos": [
                {
                    "clinica": "Clínica del Sol",
                    "especialidad": "Doppler Vascular",
                    "procedimiento": "ECO DOPPLER VENOSO  M.M.I.I. COLOR",
                    "indicacionMedica": "",
                    "estadoPedido": "LIBERADO",
                    "estadoPrescripcion": "NO PRESCRITO",
                    "atencion": "Sin Atencion",
                    "estadoAgenda": "NO AGENDADO",
                    "estadoFinal": "NO AGENDADO / NO ATENDIDO"
                },
                {
                    "clinica": "Clínica del Sol",
                    "especialidad": "Ecocardiografia",
                    "procedimiento": "ECO DOPPLER VENOSO  M.M.I.I. COLOR",
                    "indicacionMedica": "*Concurrir con estudios previos relacionados con el examen a realizar y con 15 minutos de anticipación para realizar la admisión",
                    "estadoPedido": "LIBERADO",
                    "estadoPrescripcion": "NO PRESCRITO",
                    "atencion": "Sin Atencion",
                    "estadoAgenda": "NO AGENDADO",
                    "estadoFinal": "NO AGENDADO / NO ATENDIDO"
                }
            ]
        },
        {
            "dni": "5301249",
            "nombre": "AMANDA ELVIRA RODRIGUEZ",
            "telefono": "1159580601",
            "telefonoCelular": "",
            "email": "amandaelvirarodriguez@gmail.com",
            "nroPedido": "4494",
            "fechaEmision": "03/02/2026",
            "situacion": "A",
            "procedimientos": [
                {
                    "clinica": "Clínica del Sol",
                    "especialidad": "Cardiologia",
                    "procedimiento": "MAPA DE PRESION- PRESUROMETRIA",
                    "indicacionMedica": "* El paciente debe traer al estudio 2 Pilas Nuevas Doble A\n** Las personas con vellosidad abundante en el tórax, traer afeitadora descartable, para realizar rasurado, en caso que fuese necesario",
                    "estadoPedido": "LIBERADO",
                    "estadoPrescripcion": "NO PRESCRITO",
                    "atencion": "Sin Atencion",
                    "estadoAgenda": "NO AGENDADO",
                    "estadoFinal": "NO AGENDADO / NO ATENDIDO"
                }
            ]
        },
        {
            "dni": "5301249",
            "nombre": "AMANDA ELVIRA RODRIGUEZ",
            "telefono": "1159580601",
            "telefonoCelular": "",
            "email": "amandaelvirarodriguez@gmail.com",
            "nroPedido": "4495",
            "fechaEmision": "03/02/2026",
            "situacion": "A",
            "procedimientos": [
                {
                    "clinica": "Clínica del Sol",
                    "especialidad": "Clinica Medica",
                    "procedimiento": "Control GLUCEMIA por PROTOCOLO",
                    "indicacionMedica": "",
                    "estadoPedido": "LIBERADO",
                    "estadoPrescripcion": "NO PRESCRITO",
                    "atencion": "Sin Atencion",
                    "estadoAgenda": "NO AGENDADO",
                    "estadoFinal": "NO AGENDADO / NO ATENDIDO"
                },
                {
                    "clinica": "Clínica del Sol",
                    "especialidad": "Clinica Medica",
                    "procedimiento": "Control GLUCEMIA por PROTOCOLO",
                    "indicacionMedica": "",
                    "estadoPedido": "LIBERADO",
                    "estadoPrescripcion": "NO PRESCRITO",
                    "atencion": "Sin Atencion",
                    "estadoAgenda": "NO AGENDADO",
                    "estadoFinal": "NO AGENDADO / NO ATENDIDO"
                },
                {
                    "clinica": "Clínica del Sol",
                    "especialidad": "Laboratorio",
                    "procedimiento": "CREATININA EN SANGRE",
                    "indicacionMedica": "Concurrir con estudios previos relacionados con el examen a realizar y con 15 minutos de anticipación para realizar la admisión",
                    "estadoPedido": "LIBERADO",
                    "estadoPrescripcion": "NO PRESCRITO",
                    "atencion": "Sin Atencion",
                    "estadoAgenda": "NO AGENDADO",
                    "estadoFinal": "NO AGENDADO / NO ATENDIDO"
                },
                {
                    "clinica": "Clínica del Sol",
                    "especialidad": "Laboratorio",
                    "procedimiento": "CREATININA EN SANGRE",
                    "indicacionMedica": "Concurrir con estudios previos relacionados con el examen a realizar y con 15 minutos de anticipación para realizar la admisión",
                    "estadoPedido": "LIBERADO",
                    "estadoPrescripcion": "NO PRESCRITO",
                    "atencion": "Sin Atencion",
                    "estadoAgenda": "NO AGENDADO",
                    "estadoFinal": "NO AGENDADO / NO ATENDIDO"
                },
                {
                    "clinica": "Clínica del Sol",
                    "especialidad": "Laboratorio",
                    "procedimiento": "ERITROSEDIMENTACION",
                    "indicacionMedica": "Concurrir con estudios previos relacionados con el examen a realizar y con 15 minutos de anticipación para realizar la admisión",
                    "estadoPedido": "LIBERADO",
                    "estadoPrescripcion": "NO PRESCRITO",
                    "atencion": "Sin Atencion",
                    "estadoAgenda": "NO AGENDADO",
                    "estadoFinal": "NO AGENDADO / NO ATENDIDO"
                },
                {
                    "clinica": "Clínica del Sol",
                    "especialidad": "Laboratorio",
                    "procedimiento": "Control GLUCEMIA por PROTOCOLO",
                    "indicacionMedica": "Concurrir con estudios previos relacionados con el examen a realizar y con 15 minutos de anticipación para realizar la admisión",
                    "estadoPedido": "LIBERADO",
                    "estadoPrescripcion": "NO PRESCRITO",
                    "atencion": "Sin Atencion",
                    "estadoAgenda": "NO AGENDADO",
                    "estadoFinal": "NO AGENDADO / NO ATENDIDO"
                },
                {
                    "clinica": "Clínica del Sol",
                    "especialidad": "Laboratorio",
                    "procedimiento": "HEMOGLOBINA GLICOSILADA",
                    "indicacionMedica": "Concurrir con estudios previos relacionados con el examen a realizar y con 15 minutos de anticipación para realizar la admisión",
                    "estadoPedido": "LIBERADO",
                    "estadoPrescripcion": "NO PRESCRITO",
                    "atencion": "Sin Atencion",
                    "estadoAgenda": "NO AGENDADO",
                    "estadoFinal": "NO AGENDADO / NO ATENDIDO"
                },
                {
                    "clinica": "Clínica del Sol",
                    "especialidad": "Laboratorio",
                    "procedimiento": "HEMOGRAMA",
                    "indicacionMedica": "INDICACIONES PARA PACIENTES: \n*Concurrir con estudios previos relacionados con el examen a realizar y con 15 minutos de anticipación para realizar la admisión",
                    "estadoPedido": "LIBERADO",
                    "estadoPrescripcion": "NO PRESCRITO",
                    "atencion": "Sin Atencion",
                    "estadoAgenda": "NO AGENDADO",
                    "estadoFinal": "NO AGENDADO / NO ATENDIDO"
                },
                {
                    "clinica": "Clínica del Sol",
                    "especialidad": "Laboratorio",
                    "procedimiento": "HEPATOGRAMA O HEPATOGRAMA COMPLETO",
                    "indicacionMedica": "Concurrir con estudios previos relacionados con el examen a realizar y con 15 minutos de anticipación para realizar la admisión",
                    "estadoPedido": "LIBERADO",
                    "estadoPrescripcion": "NO PRESCRITO",
                    "atencion": "Sin Atencion",
                    "estadoAgenda": "NO AGENDADO",
                    "estadoFinal": "NO AGENDADO / NO ATENDIDO"
                },
                {
                    "clinica": "Clínica del Sol",
                    "especialidad": "Laboratorio",
                    "procedimiento": "IONOGRAMA PLASMATICO",
                    "indicacionMedica": "Concurrir con estudios previos relacionados con el examen a realizar y con 15 minutos de anticipación para realizar la admisión",
                    "estadoPedido": "LIBERADO",
                    "estadoPrescripcion": "NO PRESCRITO",
                    "atencion": "Sin Atencion",
                    "estadoAgenda": "NO AGENDADO",
                    "estadoFinal": "NO AGENDADO / NO ATENDIDO"
                },
                {
                    "clinica": "Clínica del Sol",
                    "especialidad": "Laboratorio",
                    "procedimiento": "ORINA COMPLETA",
                    "indicacionMedica": "Concurrir con estudios previos relacionados con el examen a realizar y con 15 minutos de anticipación para realizar la admisión",
                    "estadoPedido": "LIBERADO",
                    "estadoPrescripcion": "NO PRESCRITO",
                    "atencion": "Sin Atencion",
                    "estadoAgenda": "NO AGENDADO",
                    "estadoFinal": "NO AGENDADO / NO ATENDIDO"
                },
                {
                    "clinica": "Clínica del Sol",
                    "especialidad": "Laboratorio",
                    "procedimiento": "ORINA COMPLETA",
                    "indicacionMedica": "Concurrir con estudios previos relacionados con el examen a realizar y con 15 minutos de anticipación para realizar la admisión",
                    "estadoPedido": "LIBERADO",
                    "estadoPrescripcion": "NO PRESCRITO",
                    "atencion": "Sin Atencion",
                    "estadoAgenda": "NO AGENDADO",
                    "estadoFinal": "NO AGENDADO / NO ATENDIDO"
                },
                {
                    "clinica": "Clínica del Sol",
                    "especialidad": "Laboratorio",
                    "procedimiento": "PLAQUETAS. RECUENTO DE",
                    "indicacionMedica": "Concurrir con estudios previos relacionados con el examen a realizar y con 15 minutos de anticipación para realizar la admisión",
                    "estadoPedido": "LIBERADO",
                    "estadoPrescripcion": "NO PRESCRITO",
                    "atencion": "Sin Atencion",
                    "estadoAgenda": "NO AGENDADO",
                    "estadoFinal": "NO AGENDADO / NO ATENDIDO"
                },
                {
                    "clinica": "Clínica del Sol",
                    "especialidad": "Laboratorio",
                    "procedimiento": "PLAQUETAS. RECUENTO DE",
                    "indicacionMedica": "Concurrir con estudios previos relacionados con el examen a realizar y con 15 minutos de anticipación para realizar la admisión",
                    "estadoPedido": "LIBERADO",
                    "estadoPrescripcion": "NO PRESCRITO",
                    "atencion": "Sin Atencion",
                    "estadoAgenda": "NO AGENDADO",
                    "estadoFinal": "NO AGENDADO / NO ATENDIDO"
                },
                {
                    "clinica": "Clínica del Sol",
                    "especialidad": "Laboratorio",
                    "procedimiento": "TRIGLICERIDOS",
                    "indicacionMedica": "Concurrir con estudios previos relacionados con el examen a realizar y con 15 minutos de anticipación para realizar la admisión",
                    "estadoPedido": "LIBERADO",
                    "estadoPrescripcion": "NO PRESCRITO",
                    "atencion": "Sin Atencion",
                    "estadoAgenda": "NO AGENDADO",
                    "estadoFinal": "NO AGENDADO / NO ATENDIDO"
                },
                {
                    "clinica": "Clínica del Sol",
                    "especialidad": "Laboratorio",
                    "procedimiento": "UREMIA",
                    "indicacionMedica": "Concurrir con estudios previos relacionados con el examen a realizar y con 15 minutos de anticipación para realizar la admisión",
                    "estadoPedido": "LIBERADO",
                    "estadoPrescripcion": "NO PRESCRITO",
                    "atencion": "Sin Atencion",
                    "estadoAgenda": "NO AGENDADO",
                    "estadoFinal": "NO AGENDADO / NO ATENDIDO"
                },
                {
                    "clinica": "Clínica del Sol",
                    "especialidad": "Laboratorio",
                    "procedimiento": "TIROTROFINA (TSH)",
                    "indicacionMedica": "Concurrir con estudios previos relacionados con el examen a realizar y con 15 minutos de anticipación para realizar la admisión",
                    "estadoPedido": "LIBERADO",
                    "estadoPrescripcion": "NO PRESCRITO",
                    "atencion": "Sin Atencion",
                    "estadoAgenda": "NO AGENDADO",
                    "estadoFinal": "NO AGENDADO / NO ATENDIDO"
                },
                {
                    "clinica": "Clínica del Sol",
                    "especialidad": "Laboratorio",
                    "procedimiento": "INSULINA",
                    "indicacionMedica": "Concurrir con estudios previos relacionados con el examen a realizar y con 15 minutos de anticipación para realizar la admisión",
                    "estadoPedido": "LIBERADO",
                    "estadoPrescripcion": "NO PRESCRITO",
                    "atencion": "Sin Atencion",
                    "estadoAgenda": "NO AGENDADO",
                    "estadoFinal": "NO AGENDADO / NO ATENDIDO"
                },
                {
                    "clinica": "Clínica del Sol",
                    "especialidad": "Laboratorio",
                    "procedimiento": "INSULINA",
                    "indicacionMedica": "Concurrir con estudios previos relacionados con el examen a realizar y con 15 minutos de anticipación para realizar la admisión",
                    "estadoPedido": "LIBERADO",
                    "estadoPrescripcion": "NO PRESCRITO",
                    "atencion": "Sin Atencion",
                    "estadoAgenda": "NO AGENDADO",
                    "estadoFinal": "NO AGENDADO / NO ATENDIDO"
                },
                {
                    "clinica": "Clínica del Sol",
                    "especialidad": "Laboratorio",
                    "procedimiento": "COLESTEROL TOTAL",
                    "indicacionMedica": "Concurrir con estudios previos relacionados con el examen a realizar y con 15 minutos de anticipación para realizar la admisión",
                    "estadoPedido": "LIBERADO",
                    "estadoPrescripcion": "NO PRESCRITO",
                    "atencion": "Sin Atencion",
                    "estadoAgenda": "NO AGENDADO",
                    "estadoFinal": "NO AGENDADO / NO ATENDIDO"
                },
                {
                    "clinica": "Clínica del Sol",
                    "especialidad": "Laboratorio",
                    "procedimiento": "COLESTEROL LDL",
                    "indicacionMedica": "Concurrir con estudios previos relacionados con el examen a realizar y con 15 minutos de anticipación para realizar la admisión",
                    "estadoPedido": "LIBERADO",
                    "estadoPrescripcion": "NO PRESCRITO",
                    "atencion": "Sin Atencion",
                    "estadoAgenda": "NO AGENDADO",
                    "estadoFinal": "NO AGENDADO / NO ATENDIDO"
                },
                {
                    "clinica": "Clínica del Sol",
                    "especialidad": "Laboratorio",
                    "procedimiento": "COLESTEROL HDL",
                    "indicacionMedica": "Concurrir con estudios previos relacionados con el examen a realizar y con 15 minutos de anticipación para realizar la admisión",
                    "estadoPedido": "LIBERADO",
                    "estadoPrescripcion": "NO PRESCRITO",
                    "atencion": "Sin Atencion",
                    "estadoAgenda": "NO AGENDADO",
                    "estadoFinal": "NO AGENDADO / NO ATENDIDO"
                },
                {
                    "clinica": "Clínica del Sol",
                    "especialidad": "Laboratorio",
                    "procedimiento": "HEMOGRAMA",
                    "indicacionMedica": "Concurrir con estudios previos relacionados con el examen a realizar y con 15 minutos de anticipación para realizar la admisión",
                    "estadoPedido": "LIBERADO",
                    "estadoPrescripcion": "NO PRESCRITO",
                    "atencion": "Sin Atencion",
                    "estadoAgenda": "NO AGENDADO",
                    "estadoFinal": "NO AGENDADO / NO ATENDIDO"
                }
            ]
        }
    ]
}
